import { useEffect, useState } from "react";
import "./style.scss";

const CookieNotification = () => {
    const [cookieConsent, setCookieConsent] = useState(false);

    useEffect(() => {
        const cookieValue = getCookie("_rispromo_cookie");
        if (!cookieValue) setCookieConsent(true);
    }, []);

    const setCookie = (name, value, days) => {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        const expires = `expires=${date.toUTCString()}`;
        document.cookie = `${name}=${value}; ${expires}; path=/`;
    };

    const getCookie = (name) => {
        const cookiesArray = document.cookie.split("; ");
        for (let i = 0; i < cookiesArray.length; i++) {
            const [cookieName, cookieValue] = cookiesArray[i].split("=");
            if (cookieName === name) {
                return cookieValue;
            }
        }
        return null;
    };

    const handleClickCookies = () => {
        setCookie("_rispromo_cookie", "true", 365);
        setCookieConsent(false);
    };
    return cookieConsent ? (
        <div className="cookie">
            <div className="cookie__container">
                <div className="cookie__content">
                    <button onClick={handleClickCookies} className="cookie__button">
                        ОК
                    </button>

                    <p className="cookie__text">
                        Продолжая использовать наш сайт, вы соглашаетесь с нашей{" "}
                        <a href="/pdf/policy.pdf" target="_blank" className="cookie__link">
                            политикой конфиденциальности
                        </a>{" "}
                        и использованием файлов cookie.
                    </p>
                </div>
            </div>
        </div>
    ) : null;
};

export default CookieNotification;
